<script>
  import {clone,cloneDeep,merge,isObject,isString,isEqual,get,has} from 'lodash'
  import {transformStrByEval,forOwnWithPath} from '@/utils/commonUtils'
  import Vue from 'vue'
  export default {
    name: "vue-json-layout2",
    props:{
      layout:{
        type:Object,
        required:true
      },
      externalData:{
        type:Object,
        default:()=>{return {}}
      }
    },
    data(){
      return {
        data:{},
        evaledLayout:{},
      }
    },
    methods:{
      getEvalContext(additionContext){
        return merge({"vue":this},additionContext)
      },
      refreshEvaledLayout(layout,evaledLayout,evalContext,self){
        function evalFun(evalObj,destObj,evalContext){
          forOwnWithPath(evalObj,(path,v,key,obj)=>{
            if (isObject(v)&&v.$method) return true;//ignory

            if (isString(v)&&v.startsWith("{") && v.endsWith("}")){
              const evaledValue = transformStrByEval(v, evalContext);
              if (!isEqual(get(destObj, path), evaledValue)) Vue.$nestedSet(destObj, path, evaledValue);

              if (!has(destObj,path)) Vue.$nestedSet(destObj, path, undefined);//если значение не определено, то явно проставляем у него значение свойства undefined
              return;
            }
            if (!has(destObj,path)){
              isObject(v)
                ?Vue.$nestedSet(destObj,path,v.constructor())
                :Vue.$nestedSet(destObj,path,v)
            }
          })
        }

        if (layout.data)  evalFun(layout.data,self.data,evalContext)

        if (!evaledLayout.component) Vue.set(evaledLayout,'component',layout.component);

        if (!evaledLayout.params) Vue.set(evaledLayout,'params',{});

        if (layout.vIf){
          const condition = transformStrByEval(layout.vIf,evalContext)
          if (!has(evaledLayout,'vIf')) Vue.set(evaledLayout, 'vIf', undefined);
          if (!isEqual(evaledLayout.vIf, condition)) Vue.set(evaledLayout, 'vIf', condition);
          if (!condition) return;//прекращаем дальнейшие действия если условия не выполняются
        }

        evalFun(layout.params,evaledLayout.params,evalContext);

        if (layout.children){
          if (!evaledLayout.children) Vue.set(evaledLayout,'children',[])
          layout.children.forEach((childLayout,index)=>{
            if (isObject(childLayout)&&childLayout.component){
              if (!evaledLayout.children[index]) Vue.set(evaledLayout.children,index,{})
              this.refreshEvaledLayout(childLayout,evaledLayout.children[index],evalContext,self)
            }else{
              Vue.set(evaledLayout.children,index,childLayout)//TODO продумать
            }

          })
        }

      },

    },
    watch:{
      externalData:{
        immediate:true,
        deep:true,
        handler(){
          this.refreshEvaledLayout(this.layout,this.evaledLayout,this.getEvalContext(),this);
        }
      },
      data:{
        deep:true,
        handler(){
          this.refreshEvaledLayout(this.layout,this.evaledLayout,this.getEvalContext(),this);
        }
      }
    },
    render(createElement) {

      const renderEvaledLayout = (createElement,evaledLayout)=>{

        if (!evaledLayout.component) return;

        if (has(evaledLayout,'vIf')&&!evaledLayout.vIf) return;

        const clonedParams = clone(evaledLayout.params);

        const children = (evaledLayout.children||[])
                              .filter(e=>e)
                              .map(e=>isObject(e)&&e.component
                                ?renderEvaledLayout(createElement,e)
                                :isString(e)
                                  ?transformStrByEval(e,self.getEvalContext())
                                  :e
                              )

        return createElement(
          evaledLayout.component,
          clonedParams,
          children
        )
      }

      return renderEvaledLayout(createElement,this.evaledLayout)
    }
  }
</script>


